import {
  FileText,
  LayoutDashboard,
  ListChecks,
  type LucideIcon,
  NotebookPen,
  Package,
  ShoppingCart,
} from 'lucide-react';
import { msg } from '@/shared/i18n/msg';

type NavigationItem = {
  readonly to: string;
  /** An English key, translated where it is rendered. */
  readonly label: string;
  readonly icon: LucideIcon;
  /** Shown in the phone's bottom bar; the rest are in the sidebar sheet opened by "More". */
  readonly primary: boolean;
};

/** The sections of the kit, in the sidebar and (the primary ones) in the phone's bottom bar. */
export const NAVIGATION: readonly NavigationItem[] = [
  { to: '/', label: msg('Dashboard'), icon: LayoutDashboard, primary: true },
  { to: '/inventory', label: msg('Inventory'), icon: Package, primary: true },
  { to: '/shopping', label: msg('Shopping'), icon: ShoppingCart, primary: true },
  { to: '/tasks', label: msg('Tasks'), icon: ListChecks, primary: true },
  { to: '/documents', label: msg('Documents'), icon: FileText, primary: false },
  { to: '/notes', label: msg('Notes'), icon: NotebookPen, primary: false },
];
